// removed by extract-text-webpack-plugin
module.exports = {"Spotlight":"Spotlight__Spotlight___3Pkfm","SpotlightShadow":"Spotlight__SpotlightShadow___kF7Zq","SpotlightHeroContent":"Spotlight__SpotlightHeroContent___1B8BD"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Spotlight/Spotlight.less
// module id = 1301
// module chunks = 0 1